import React, {useState, useCallback, useRef, useEffect, useMemo} from 'react';
import { useTaskforceListSelector } from '../../../../../../store/selectors/team.selectors';
import { useUserSelector } from '../../../../../../store/selectors/authorization.selectors';
import {
    useActiveTaskSelector
} from '../../../../../../store/selectors/task/task.selectors';
import { TaskThunk } from '../../../../../../store/thunk/task.thunk';
import {CheckList, CheckListModel} from '../../../../../../models/checklist-model';
import { useDispatch } from 'react-redux';
import EventTextModel from '../../../../../../models/event-text-model.enum';
import TaskStatusModel from '../../../../../../models/responses/task-status.model';
import TaskChecklist from './components/TaskChecklist';
import TaskAddChecklist from './components/TaskAddChecklist';
import uuid from "uuid";
import { MessageType } from '../../../../../../models/responses/message.model';
import {useChecklistMapSelector} from '../../../../../../store/selectors/project.selectors';
import {
  faAngleDown,
  faAngleUp,
    faListCheck,
} from "@fortawesome/pro-light-svg-icons";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {TaskListSectionModel} from "../../../../../../models/task-list-section.model";
import {
    useWorkPackageMapSelector,
} from "../../../../../../store/selectors/work-packages.selectors";
const TaskCheckListWrapper: React.FC = (props) => {
    const [inputValue, setInputValue] = useState<string>('');
    const [isCheckListOpened, setIsCheckListOpened] = useState<boolean>(false);
    const [isLockOpened, setIsLockOpened] = useState<boolean>(false);
    const taskforceMembers = useTaskforceListSelector();
    const user = useUserSelector();
    const activeTask = useActiveTaskSelector();
    const dispatch = useDispatch();
    const inputRef = useRef<any>(null);
    const [opened, setOpened] = useState<boolean>(false);
    const [isActive, setIsActive] = useState(activeTask ? activeTask.taskListType === TaskListSectionModel.QUEUED ? true : false : false);
    // @ts-ignore
    const [eventText, setEventText] = useState<EventTextModel>(EventTextModel.EVENT_DESCRIPTION);
    const [activeChecklistItem, setActiveChecklistItem] = useState<CheckList | null>(null);
    const checklistMap = useChecklistMapSelector();
    const workPackageMap = useWorkPackageMapSelector();

    useEffect(() => {
        if (isCheckListOpened && inputRef.current) {
          inputRef.current.focus();
        }
    }, [isCheckListOpened]);

    const updateCheckListLock = useCallback(() => {
      if (activeTask) {
        setEventText(EventTextModel.ADD_EVENT_LOG);
        // @ts-ignore
        dispatch(TaskThunk.addEventLog(activeTask.task_id, activeTask.task_code, MessageType.CHK, activeTask.taskListType));
        // @ts-ignore
        dispatch(TaskThunk.completeChecklistNotification(activeTask.task_id));
            // @ts-ignore
        dispatch(TaskThunk.updateCheckListLock(activeTask.task_id, true, activeTask.taskListType));
      }
    },[activeTask, dispatch]);

    const addCheckListHandler = useCallback(() => {
      if (activeTask && inputValue) {
        const checklist: CheckList[] = [
          ...Array.isArray(activeTask.checklist) ? activeTask.checklist : [],
          {
              name: inputValue,
              isChecked: false,
              id: uuid.v4(),
          }
        ]
        // @ts-ignore
        dispatch(TaskThunk.updateChecklist(checklist, activeTask.task_id, activeTask.taskListType));
      }
      setInputValue('');
    }, [inputValue, activeTask, dispatch]);

    const addImportedCheckListHandler = useCallback(() => {
        if (activeTask) {
          // @ts-ignore
          dispatch(TaskThunk.updateChecklist(activeTask.importedChecklist, activeTask.task_id, activeTask.taskListType));
        }
    }, [activeTask, dispatch]);

    const lockChecklist = () => {
      updateCheckListLock();
      setIsLockOpened(false);
    }

    const checklistItemChangeHandler = useCallback((item: CheckList) => {
      if (activeTask) {
          item = {
            ...item,
            userEmail: user!.userEmail,
            checkedDate: new Date(),
          };
          const checklist = [...Array.isArray(activeTask.checklist) ? activeTask.checklist : []]
          .map(el => el.id === item.id ? item : el);
          // @ts-ignore
          dispatch(TaskThunk.updateChecklist(checklist, activeTask.task_id, activeTask.taskListType));
        }
        setActiveChecklistItem(item);
    }, [activeTask, dispatch]);

    const removeCheckListHandler = useCallback((itemId: string) => {
        if (activeTask) {
            const checklist = [...Array.isArray(activeTask.checklist) ? activeTask.checklist : []]
                .filter(el => el.id !== itemId);
            // @ts-ignore
            dispatch(TaskThunk.updateChecklist(checklist, activeTask.task_id, activeTask.taskListType));
        }
    }, [activeTask, dispatch]);

    const isUserTaskforceMember = taskforceMembers.some(
      (member) => member.userEmail === user!.userEmail
    );

    const checklist: CheckListModel = useMemo(() => {
            if (activeTask && activeTask.checklistId) {
                return checklistMap.get(activeTask.checklistId)
            } else if (activeTask && activeTask.workPackage && activeTask.workPackage.workPackageId) {
                const workPackage = workPackageMap.get(activeTask.workPackage.workPackageId);
                if (!workPackage || !workPackage.checklistId) {
                    return null;
                }
                return checklistMap.get(workPackage.checklistId);
            }
            return null
        }
    , [activeTask])

    return activeTask &&
      <div
        className={
          "checklist-wrapper flex"
        }
      >
        {activeTask && checklist ? (
          <>
            <div
              className="collapse-title"
              onClick={() => setIsActive(!isActive)}
            >
              {
                <FontAwesomeIcon
                  icon={!isActive ? faAngleDown : faAngleUp}
                  className="chevron-icon"
                />
              }
              <p className="calendar-title" style={{ marginBottom: "unset" }}>
                  {checklist.checklistName} ({activeTask && activeTask.completedChecklist ? activeTask.completedChecklist.length : 0}/{checklist.items.length})
                  <FontAwesomeIcon icon={faListCheck} style={{marginLeft: "7px", fontSize: "16px"}}/>
              </p>
            </div>
            {isActive && (
              <TaskChecklist
                taskChecklist={checklist.items}
                onChangeHandler={checklistItemChangeHandler}
                removeHandler={removeCheckListHandler}
                eventText={eventText}
                opened={opened}
                setOpened={setOpened}
                activeItem={activeChecklistItem}
                setActiveItem={setActiveChecklistItem}
                disabled={!isUserTaskforceMember}
                type={activeTask.checklistId ? 'task' : 'workPackage'}
              />
            )}
          </>
        ) : null}
        {
            (!activeTask.checklistId || isActive) && !activeTask?.completedChecklist &&
            (activeTask?.status === TaskStatusModel.BLOCK || activeTask?.status === TaskStatusModel.NOT_STARTED) &&
            isUserTaskforceMember &&
            (<TaskAddChecklist
              isChecklistOpened={isCheckListOpened}
              setIsChecklistOpened={setIsCheckListOpened}
              isLockOpened={isLockOpened}
              setIsLockOpened={setIsLockOpened}
              taskChecklist={activeTask.checklist}
              addChecklistHandler={addCheckListHandler}
              addImportedChecklistHandler={addImportedCheckListHandler}
              lockChecklist={lockChecklist}
              inputValue={inputValue}
              setInputValue={setInputValue}
              inputRef={inputRef}
              activeTask={activeTask}
              disabled={!isUserTaskforceMember}
            />
          )}
      </div>
    // ) : null;
}

export default TaskCheckListWrapper;
